export var ENTITY = "payment-order";
export var REDUCER_KEY = "PAYMENT_ORDERS_V2";
export var BASE_PATH_ENTITY = "payment-orders";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
